module.exports = __webpack_public_path__ + "static/media/3.55cbf42a.png";